import { render, staticRenderFns } from "./OpportunitiesCard.vue?vue&type=template&id=4e731a87&scoped=true"
import script from "./OpportunitiesCard.vue?vue&type=script&lang=js"
export * from "./OpportunitiesCard.vue?vue&type=script&lang=js"
import style0 from "./OpportunitiesCard.vue?vue&type=style&index=0&id=4e731a87&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e731a87",
  null
  
)

export default component.exports